const replace = (str, locale, mergeFields) => {
    let text = ''
    const regex = new RegExp(/\[([^\]]*)\]/)
    let match = regex.exec(str)
    while (match) {
        // console.log(match)
        const [strMatch, token] = match
        const { index } = match
        let mergeValue = strMatch
        const mergeField = mergeFields[token.toLowerCase()]
        if (mergeField) {
            mergeValue = typeof mergeField === 'string' ? mergeField.replace(/&amp;/gi, '&')
                : mergeField[locale] || mergeValue
        }
        text += str.substr(0, index) + mergeValue
        str = str.substr(index + strMatch.length)
        match = regex.exec(str)
    }
    text += str
    return text
}

export default {
    replace,
}
